<app-label-inflator
  #labelCalculator
  hidden
  class="print-card-label"
  [columnLabel]="false"
  [labelComponentInterface]="data"
  [reset]="false">
</app-label-inflator>

<div class="header" [style.color]="viewModel.headerTextColor$ | async">{{ viewModel.headerText$ | async }}</div>
<div class="main-content" [style.color]="viewModel.bodyTextColor$ | async">
  <div class="top-content">
    <div class="miss-jones-brand">{{ data | method: 'getBrand' }}</div>
    <img appImage class="miss-jones-logo" src="" alt="mj" [localAsset]="'/assets/images/miss-jones/mj.png'" />
  </div>
  @let hasCraftDesignation = viewModel.hasCraftDesignation$ | async;
  <div *rxIf="hasCraftDesignation" class="craft-badge-container">
    <img
      appImage
      [localAsset]="'assets/images/the-woods-cannabis/ocs_craft_badge.png'"
      class="craft-badge"
      alt="craft badge"
      src="" />
  </div>
  <div class="center-content" [class.no-craft-badge]="!hasCraftDesignation">
    <div
      *ngIf="data | method: 'getRowTitle' as title"
      appPrintCardScaleDownText
      [maxHeightInPx]="hasCraftDesignation ? 50 : 115"
      [adjustLineHeight]="false"
      [transparentWhileScaling]="viewModel.viewingInLiveView$ | async"
      class="product-name">
      {{ title | trimSafely }}
    </div>
    <div class="strain-label-badge-container">
      <div
        *ngIf="viewModel.strainText$ | async as strainType"
        class="strain-type"
        [style.color]="viewModel.headerTextColor$ | async">
        {{ strainType | trimSafely }}
      </div>
      <app-label-inflator
        *ngIf="viewModel.labelText$ | async"
        class="label"
        [columnLabel]="false"
        [labelComponentInterface]="data"
        [reset]="false">
      </app-label-inflator>
      <div
        *ngIf="(data?.menu | printCardMenuBasicMethod: 'getNumberOfBadgesForVariant' : data) > 0"
        class="badge-container">
        <img
          *ngFor="let variantBadge of data | printCardBadges"
          appImage
          class="badge"
          [asset]="variantBadge?.image"
          alt="badge"
          src="" />
      </div>
    </div>
    <app-print-card-description-container
      [cardData]="data"
      [bodyTextColor]="viewModel.bodyTextColor$ | async"></app-print-card-description-container>
  </div>
  <div class="bottom-content">
    <div class="properties-and-price">
      <div class="properties">
        <div *ngIf="viewModel.experienceText$ | async" class="property-container">
          <span class="title">EXPERIENCE: </span>
          <span class="value">{{ viewModel.experienceText$ | async | uppercase }}</span>
        </div>
        <div *ngFor="let data of viewModel.propertiesBasedOnPools$ | async" class="property-container">
          <div class="title">{{ data?.title }}:</div>
          <div class="value">
            {{ data?.value }}
          </div>
        </div>
      </div>
      <div class="product-card-price">
        <app-column-primary-price
          [style.display]="'contents'"
          [menu]="viewModel.cardStackMenu$ | async"
          [section]="viewModel.cardStack$ | async"
          [colVm]="viewModel.spoofedColViewModel$ | async"
          [rowVm]="viewModel.cardData$ | async"
          [locConfig]="viewModel.locationConfig$ | async"
          [locationId]="viewModel.locationId$ | async"
          [productStylingVm]="viewModel">
        </app-column-primary-price>
      </div>
    </div>
    <div class="product-notes-and-sizing">
      <div class="notes-container">
        <div class="notes">
          <div class="title">FLAVOUR NOTES</div>
          <div class="info">{{ viewModel.flavorNotes$ | async }}</div>
        </div>

        <div class="notes">
          <div class="title">TERPENE NOTES</div>
          <div class="info">{{ viewModel.terpeneNotes$ | async }}</div>
        </div>
      </div>

      <div *ngIf="viewModel.productSizeExists$ | async" class="sizing">
        {{ viewModel.productSize$ | async }}
      </div>
    </div>
  </div>
</div>
